<template>
  <div class="stop-group-item">
    <div class="stop-names">
      <div
        v-for="(stop) in stop.stop"
      >
        {{ stop.stop_name }}
      </div>
    </div>
    <div class="routes">
      <stop-route-list
        :routes="stop.routes"
        />
    </div>
  </div>
</template>
<script>
import StopRouteList from "@/components/StopInfo/StopRoutesList";
export default {
  name: 'StopGroupItem',
  components: {StopRouteList},
  props: ['stop'],
  computed: {},
  methods: {},
  mounted() {
  }
}
</script>
<style scoped>
.stop-names{
  display: flex;
  flex-wrap: wrap;
}
</style>
